import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {updateLeftMenuSidebarVisible} from '../../reducers/leftMenuSidebarReducer';
import {toggleSignInDisplayModal} from '../../reducers/homePageReducer';
import {Icon, Button} from 'semantic-ui-react';
import logoBrandLarge from '../../assets/logo_brand_large.png';
import './TopMenuBar.css';

class TopMenuBar extends Component {
  constructor(props) {
    super(props);
    this.handleMenuButtonClick = this.handleMenuButtonClick.bind(this);
  }

  handleMenuButtonClick() {
    this.props.updateLeftMenuSidebarVisible(true);
  }

  render() {
    return (
      <div className="ui menu borderless">
        <div className="item no-left-right-padding">
          <Button className="white-button" onClick={this.handleMenuButtonClick}>
            <Button.Content visible>
              <Icon name="bars" size="large" />
            </Button.Content>
          </Button>
        </div>
        <div className="item no-left-right-padding">
          <Link to="/">
            <img className="logo" src={logoBrandLarge} alt="logo" id="custom-img"/>
          </Link>
        </div>
        {/*<div className="ui item right input">*/}
          {/*<input type="text" placeholder="Email"/>*/}
        {/*</div>*/}
        {/*<div className="ui item input">*/}
          {/*<input type="password" placeholder="Password"/>*/}
        {/*</div>*/}


        {/*<div className="item right">*/}
          {/*<button className="ui animated button primary" onClick={this.props.toggleSignInDisplayModal}>*/}
            {/*<div className="visible content">*/}
              {/*<i aria-hidden="true" className="sign in icon"></i>Log In*/}
            {/*</div>*/}
            {/*<div className="hidden content">*/}
              {/*<i aria-hidden="true" className="right arrow icon"></i>*/}
            {/*</div>*/}
          {/*</button>*/}
        {/*</div>*/}
        {/*<div className="ui item">*/}
          {/*<a href="/resetpassword">Forgot Pass</a>*/}
        {/*</div>*/}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    leftMenuSidebarVisible: state.leftMenuSidebar.leftMenuSidebarVisible,
    signInModal: state.homePage.signInModal
  }),
  {
    updateLeftMenuSidebarVisible,
    toggleSignInDisplayModal
  }
)(TopMenuBar)


// WEBPACK FOOTER //
// ./src/components/TopMenuBar/TopMenuBar.js